/**
 * Transform mixed "selected" array in selection store to object.
 */

export default {
  applyToVersions: "<=2.0.6",
  type: "before",
  name: "selection store object",
  migrate(data) {
    if (!data?.selection) return data;
    if (!data?.selection?.selected?.element) {
      const selectedItems = data.selection.selected.slice(0);
      data.selection.selected = {
        area: [],
        element: [],
        relation: [],
        momentum: [],
        question: []
      };

      for (const item of selectedItems) {
        if (item?.type in data.selection.selected) {
          data.selection.selected[item.type].push(item.id);
        }
      }
    }
    return data;
  }
};
